import React, { useState, useEffect } from 'react';

// Custom Circular Progressbar Component using SVG
const CircularProgressBar = ({ targetPercentage, label, description }) => {
  const [percentage, setPercentage] = useState(0);
  const [resetKey, setResetKey] = useState(0);
  const radius = 60; // Radius of the circle
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  useEffect(() => {
    let start = 0;
    const end = targetPercentage;
    const duration = 2000;
    const stepTime = 15;

    setPercentage(0);

    const timer = setInterval(() => {
      start += Math.ceil(end / (duration / stepTime));
      if (start >= end) {
        setPercentage(end);
        clearInterval(timer);
        // Reset after a delay to loop the animation
        setTimeout(() => setResetKey(prevKey => prevKey + 1), 3000);
      } else {
        setPercentage(start);
      }
    }, stepTime);

    return () => clearInterval(timer);
  }, [targetPercentage, resetKey]);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '20px',
      position: 'relative',
      margin: '20px',
      flexDirection: 'column',
      textAlign: 'center',
    }}>
      <svg width="150" height="150" viewBox="0 0 150 150">
        {/* Trail path */}
        <circle
          cx="75"
          cy="75"
          r={radius}
          fill="none"
          stroke="rgba(255, 255, 255, 0.1)"
          strokeWidth="12"
        />
        {/* Progress path */}
        <circle
          cx="75"
          cy="75"
          r={radius}
          fill="none"
          stroke="#d4b68f"
          strokeWidth="12"
          strokeLinecap="round"
          style={{
            transform: 'rotate(-90deg)',
            transformOrigin: '75px 75px',
            transition: 'stroke-dashoffset 0.5s ease-out',
            strokeDasharray: circumference,
            strokeDashoffset: strokeDashoffset,
          }}
        />
        {/* Percentage Text */}
        <text
          x="75"
          y="75"
          textAnchor="middle"
          dominantBaseline="middle"
          fill="#fff"
          fontSize="24"
          fontWeight="bold"
        >
          {`${percentage}%`}
        </text>
      </svg>
      <div style={{
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '10px',
      }}>
        <p style={{
          fontSize: '14px',
          fontWeight: '500',
          textTransform: 'uppercase',
          color: '#d4b68f',
          margin: '0'
        }}>HAPPY</p>
        <h3 style={{
          fontSize: '26px',
          fontWeight: '700',
          margin: '5px 0',
          color: 'white',
        }}>{label}</h3>
        <p style={{
          fontSize: '14px',
          fontWeight: '400',
          color: '#94a3b8',
          maxWidth: '250px',
          lineHeight: '1.5',
          margin: '0',
        }}>{description}</p>
      </div>
    </div>
  );
};

const TestimonialStatsSection = () => {
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setInView(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    const section = document.querySelector('.testimonial-stats-container');
    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  const companyStats = [
    {
      id: 1,
      targetPercentage: 50,
      label: "Clients",
      description: "Our experience design arm, method, helps businesses."
    },
    {
      id: 2,
      targetPercentage: 70,
      label: "Projects",
      description: "Our experience design arm, method, helps businesses."
    },
    {
      id: 3,
      targetPercentage: 35,
      label: "Awards",
      description: "Our experience design arm, method, helps businesses."
    },
  ];

  return (
    <div
      className="testimonial-stats-container"
      style={{
        backgroundColor: '#0f172a',
        padding: '60px 20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden',
        fontFamily: 'sans-serif',
      }}
    >
      <div style={{
        position: 'relative',
        zIndex: 2,
        display: 'flex',
        gap: '40px',
        maxWidth: '1200px',
        width: '100%',
        justifyContent: 'center',
        flexWrap: 'wrap',
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(30px)',
        transition: 'opacity 0.8s ease-out, transform 0.8s ease-out',
      }}>
        {companyStats.map(stat => (
          <CircularProgressBar
            key={stat.id}
            targetPercentage={stat.targetPercentage}
            label={stat.label}
            description={stat.description}
          />
        ))}
      </div>
    </div>
  );
};

export default TestimonialStatsSection;
